import styled, { css } from 'styled-components';

import { type CardSizes } from '@pkg/components';

export const Wrapper = styled.div<{ $cardSize?: CardSizes }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow: hidden;
    width: 100%;
    height: 30px;

    gap: 8px;

    ${({ $cardSize }) => {
        if ($cardSize === 'medium') {
            return css`
                height: 24px;
            `;
        }
        if ($cardSize === 'small') {
            return css`
                height: auto;
            `;
        }
    }}
`;
